import React, { useEffect, useState } from "react";
import axios from "axios";
import { X, Megaphone, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewUpdatesPopup = () => {
  const { t, isAr } = useLang();
  const [item, setItem] = useState(null);

  useEffect(() => {
    let active = true;
    axios.get(`${API}/tax-updates`).then((res) => {
      if (!active) return;
      const list = res.data || [];
      if (!list.length) return;
      const newest = list[0];
      const key = newest.id || (newest.date + newest.title_en);
      const seen = localStorage.getItem("sav_seen_update");
      if (seen !== key) {
        setItem({ ...newest, _key: key });
      }
    }).catch(() => {});
    return () => { active = false; };
  }, []);

  if (!item) return null;
  const dismiss = () => { localStorage.setItem("sav_seen_update", item._key); setItem(null); };

  return (
    <div className="fixed bottom-24 sm:bottom-5 left-4 z-[60] max-w-xs sm:max-w-sm w-[calc(100%-2rem)]" data-testid="new-update-popup">
      <div className="rounded-2xl bg-white border border-line shadow-lift overflow-hidden">
        <div className="flex items-center gap-2 bg-crimson text-white px-4 py-2.5">
          <Megaphone className="h-4 w-4" />
          <span className="text-sm font-bold">{t({ en: "New tax update", ar: "تحديث ضريبي جديد" })}</span>
          <button onClick={dismiss} className="ms-auto" aria-label="close"><X className="h-4 w-4" /></button>
        </div>
        <div className="p-4">
          <div className="text-[0.7rem] uppercase tracking-wider text-crimson-600 font-semibold">{isAr ? (item.category || "") : (item.category || "")}</div>
          <h4 className="font-display text-lg text-navy mt-1 leading-snug">{isAr ? (item.title_ar || item.title_en) : (item.title_en || item.title_ar)}</h4>
          <p className="mt-1.5 text-sm text-muted leading-snug line-clamp-3">{isAr ? (item.summary_ar || item.summary_en) : (item.summary_en || item.summary_ar)}</p>
          <div className="mt-3 flex items-center justify-between">
            <span className="text-xs text-muted" dir="ltr">{item.date}</span>
            <a href="/tax-updates" onClick={dismiss} className="inline-flex items-center gap-1 text-sm font-semibold text-navy hover:text-crimson transition-colors">
              {t({ en: "View all", ar: "عرض الكل" })} <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
